import { render, staticRenderFns } from "./LogManage.vue?vue&type=template&id=06612ee5"
import script from "./LogManage.vue?vue&type=script&lang=js"
export * from "./LogManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports